import { createFileRoute } from '@tanstack/react-router';

import { Files } from './-components';

export const Route = createFileRoute('/_staff/public-ids/$id/files/')({
  component: PublicIdFiles,
});

function PublicIdFiles() {
  const { id } = Route.useParams();

  return <Files publicId={id} />;
}
